import { TriangleAlert } from 'lucide-react'
import type { FieldErrors } from 'react-hook-form'
import { ToastContent } from '@/components/toast/toast-content'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'

export const toastPresets = {
  requestStepFailed: (toastId: string | number, description?: string) => (
    <ToastContent variant="error" toastId={toastId} className="w-130">
      <div className="flex flex-col gap-3">
        <div className="flex gap-2 items-center font-semibold text-destructive">
          <TriangleAlert size={20} />
          <p>Não conseguimos concluir esta etapa</p>
        </div>
        <p className="text-foreground/80">
          {description
            ?? 'Ocorreu uma falha ao processar sua solicitação. Nenhum dado foi perdido: tente novamente em alguns instantes.'}
        </p>
      </div>
    </ToastContent>
  ),
  blockedEnrollmentPeriod: (toastId: string | number) => (
    <ToastContent variant="error" toastId={toastId} className="w-130">
      <div className="flex flex-col gap-3">
        <div className="flex gap-2 items-center font-semibold text-destructive">
          <TriangleAlert size={20} />
          <p>Solicitação indisponível para o seu período de ingresso</p>
        </div>
        <p className="text-foreground/80">
          Alunos do seu <span className="font-bold">período de ingresso</span>{' '}
          não estão autorizados a solicitar análises no momento. Em caso de
          dúvidas, entre em contato com a secretaria da sua instituição.
        </p>
      </div>
    </ToastContent>
  ),
  hasRequestInAnalysis: (toastId: string | number, requestName: string) => (
    <ToastContent toastId={toastId} variant={'alert'} className="w-130">
      <div>
        <p className="text-foreground/80 mb-5 ">
          <p className="font-bold">
            Você já possui uma solicitação de {requestName}
          </p>{' '}
          em andamento.
        </p>
        <p>
          Aguarde o retorno da nossa equipe!{' '}
          <span className="text-foreground/80 font-bold">
            Após o indeferimento ou reprovação
          </span>{' '}
          da análise você poderá fazer uma nova solicitação.
        </p>
      </div>
    </ToastContent>
  ),
  invalidFieldsInGrantReview: (
    toastId: string | number,
    errors?: FieldErrors<MatchCoursesFormType>
  ) => (
    <ToastContent variant="error" toastId={toastId} className="w-130">
      <div className="flex flex-col gap-5">
        <div className="flex gap-2 items-center items-center font-semibold text-destructive">
          <TriangleAlert size={20} />
          <p>Você não pode realizar o [deferimento/Indeferimento]</p>
        </div>

        {errors?.courseEquivalences && (
          <div className="flex flex-col gap-1">
            <p className="font-semibold">
              Há pendências na tabela de equivalências
            </p>
            <p>
              Verifique se, para cada equivalência selecionada, o curso de
              origem, o curso de destino e os dados obrigatórios (nota, carga
              horária, período e status) estão corretamente preenchidos.
            </p>
          </div>
        )}

        {errors?.serie && (
          <div className="flex flex-col gap-1">
            <p className="font-semibold">Série de ingresso não selecionada</p>
            <p>
              Para prosseguir, é necessário informar a série de ingresso do
              estudante.
            </p>
          </div>
        )}
      </div>
    </ToastContent>
  )
}
